import React from 'react';
import { AssetUrls } from 'config/assets';
import './ManaFilters.css';

const COLOR_OPTIONS = [
  { key: 'W', label: 'White', icon: `${AssetUrls.base}/assets/icons/Search/mana-symbol-white.png` },
  { key: 'U', label: 'Blue', icon: `${AssetUrls.base}/assets/icons/Search/mana-symbol-blue.png` },
  { key: 'B', label: 'Black', icon: `${AssetUrls.base}/assets/icons/Search/mana-symbol-black.png` },
  { key: 'R', label: 'Red', icon: `${AssetUrls.base}/assets/icons/Search/mana-symbol-red.png` },
  { key: 'G', label: 'Green', icon: `${AssetUrls.base}/assets/icons/Search/mana-symbol-green.png` },
  { key: 'C', label: 'Colorless', icon: `${AssetUrls.base}/assets/icons/Search/mana-symbol-colorless.png` },
];

interface ManaFiltersProps {
  selectedColors?: string[];
  onColorToggle?: (color: string) => void;
}

export default function ManaFilters({ selectedColors = [], onColorToggle }: ManaFiltersProps) {
  const handleColorChange = (colorKey: string) => {
    if (onColorToggle) {
      onColorToggle(colorKey);
    }
  };

  return (
    <div className="mana-color-options">
      {COLOR_OPTIONS.map((color) => (
        <label key={color.key} className="mana-color-option">
          <input 
            type="checkbox" 
            checked={selectedColors.includes(color.key)}
            onChange={() => handleColorChange(color.key)}
          />
          <img src={color.icon} alt={color.label} />
          <span>{color.label}</span>
        </label>
      ))}
    </div>
  );
}
